import { useTranslation } from 'react-i18next'

import { Toolbar, Item } from 'devextreme-react/toolbar'
import { Button } from 'devextreme-react/button'

import { Form, Field } from 'formik'
import { Link } from 'react-router-dom'

import { useIxAuth } from 'contexts/auth-context'
import {
    BaseForm,
    IxLangToggle,
    TextInput,
    ErrorPanel
} from 'components'

const loginSchema = {
    $schema: 'http://json-schema.org/draft-07/schema',
    $id: 'http://example.com/example.json',
    type: 'object',
    properties: {
        username: {
            type: 'string',
            minLength: 1
        },
        password: {
            type: 'string',
            minLength: 0
        }
    },
    required: ['username']
}


export const LoginForm = () => {
    const { login, error } = useIxAuth()
    const { t } = useTranslation()

    const formikProps = {
        initialValues: { username: null, password: null },
        jsonSchema: loginSchema,
        ajvOptions: {
            coerceTypes: true,
            $data: true,
        },
        onSubmit: (values: any) => {
            if (values.password === null) {
                values.password = ''
            }
            login && login(values)
        },
    }

    return (
        <div className='rb-container' style={ { height: '100%' } }>
            <BaseForm {...formikProps}>
                {() => (
                    <Form id='login-form'>
                        { error ? <ErrorPanel err={ error as string | undefined } /> : null }
                        <Field as={TextInput} name='username' label={t('global:field.username')}/>
                        <Field as={TextInput} name='password' label={t('global:field.password')} mode='password' />
                        <Button useSubmitBehavior={true} elementAttr={{ style: 'margin-left: 1rem;'}} type='default'>{t('global:button.login')}</Button>
                    </Form>
                )}
            </BaseForm>
            <Link style={ { position: 'absolute', bottom: '1rem', right: '1rem' } } to='/sso-login'>Login with SSO</Link>
        </div>
    )
}


export const LoginTitle = () => {
    const { t } = useTranslation()
    return (
        <Toolbar elementAttr={{style: 'border-bottom: none !important;'}}>
            <Item location='before' text={t('global:button.login')} />
            <Item location='after' component={IxLangToggle} />
        </Toolbar>
    )
}


export const Login = () => {
    return (
        <div className='ix-login-overlay'>
            <div className='ix-login-panel'>
                <div className='dx-popup-title'>
                    <LoginTitle />
                </div>
                <div className='dx-popup-content'>
                    <LoginForm />
                </div>
            </div>
        </div>
    )
}
